import {
  ACTION_GET_ORG_TRANSACTIONS,
  ACTION_GET_ORG_TRANSACTIONS_SUCCESS,
  ACTION_GET_ORG_TRANSACTIONS_FAILURE,
  ACTION_GET_MORE_ORG_TRANSACTIONS,
  ACTION_GET_MORE_ORG_TRANSACTIONS_SUCCESS,
  ACTION_GET_MORE_ORG_TRANSACTIONS_FAILURE,
  ACTION_EMPTY_ORG_TRANSACTIONS,
  ACTION_EDIT_TRANSACTION,
  ACTION_EDIT_TRANSACTION_SUCCESS,
  ACTION_EDIT_TRANSACTION_FAILURE,
} from '../configs/ActionTypes';

import { Transaction, Cursor } from '../components/CompanyDetails/expenseTypes';

export type OrgTransactionsState = {
  transactions: Transaction[];
  isLoading: boolean;
  isLoadingMore: boolean;
  hasMore: boolean;
  cursor: Cursor | null;
  success: boolean | null;
};

const initialState: OrgTransactionsState = {
  transactions: [],
  isLoading: false,
  isLoadingMore: false,
  hasMore: true,
  cursor: null,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_ORG_TRANSACTIONS: {
      return { ...state, isLoading: true, success: null };
    }

    case ACTION_GET_ORG_TRANSACTIONS_SUCCESS: {
      const { data, cursor } = action.payload?.payload ?? {};
      const resolvedCursor = cursor ?? null;
      return {
        ...state,
        isLoading: false,
        transactions: data || [],
        cursor: resolvedCursor,
        hasMore: resolvedCursor !== null,
        success: null,
      };
    }

    case ACTION_GET_ORG_TRANSACTIONS_FAILURE: {
      return { ...state, isLoading: false, success: false };
    }

    case ACTION_GET_MORE_ORG_TRANSACTIONS: {
      return { ...state, isLoadingMore: true };
    }

    case ACTION_GET_MORE_ORG_TRANSACTIONS_SUCCESS: {
      const { data, cursor } = action.payload?.payload ?? {};
      const resolvedCursor = cursor ?? null;
      return {
        ...state,
        isLoadingMore: false,
        transactions: [...state.transactions, ...(data || [])],
        cursor: resolvedCursor,
        hasMore: resolvedCursor !== null,
      };
    }

    case ACTION_GET_MORE_ORG_TRANSACTIONS_FAILURE: {
      return { ...state, isLoadingMore: false };
    }

    case ACTION_EDIT_TRANSACTION: {
      return { ...state, isLoading: true, success: null };
    }

    case ACTION_EDIT_TRANSACTION_SUCCESS: {
      const updatedTransactions: Transaction[] = action.payload?.payload ?? [];
      const updatedMap = new Map(
        updatedTransactions.map((t) => [t.id, t]),
      );
      const transactions = updatedMap.size > 0
        ? state.transactions.map((t) =>
            updatedMap.has(t.id) ? { ...t, ...updatedMap.get(t.id) } : t,
          )
        : state.transactions;

      return {
        ...state,
        transactions,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_EDIT_TRANSACTION_FAILURE: {
      return { ...state, isLoading: false, success: false };
    }

    case ACTION_EMPTY_ORG_TRANSACTIONS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
